<template>
  <div>
    <div v-if="true" class="row">
      <div class="col-12">
        <div class="">
          <draggable
            tag="div"
            @end="
              endSort($event);
              drag = false;
            "
            @start="drag = true"
            :move="draggableElements"
            v-bind="dragOptions"
            :list="ModuleArray"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
              class="master-container"
            >
              <div
                class="master-box"
                v-for="(Nav, index) in ModuleArray"
                :key="index + 'drag'"
              >
                <router-link :to="Nav.url" class="d-table">
                  <h4 class="d-flex justify-content-between">
                    <span>{{ $tc(Nav.name) }}</span>
                    <!-- <i
                      class="fa fa-ellipsis-v"
                      aria-hidden="true"
                      @click="changeBgColor"
                    ></i> -->
                  </h4>
                  <img
                    src="@/assets/img/icons/arrow-right.svg"
                    width="20"
                    height="20"
                    alt
                  />
                </router-link>
              </div>
            </transition-group>
          </draggable>
          <div v-if="ModuleArray.length == 0" class="w-100 mt-5">
            <p class="no-data text-center">No Favourite modules</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Nav from "@/Nav";
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
export default {
  components: {
    draggable
  },
  data() {
    return {
      SideNav: Nav.items,
      ModuleArray: [],
      isEditable: true,
      list: [],
      drag: false,
      bgColor: "red"
    };
  },
  computed: {
    ...mapGetters(["getHotPickModules"]),
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
    //   ModulesList() {

    //     this.ModuleArray = _.sortBy(this.ModuleArray, o => o.order);
    //     this.ModuleArray.forEach((x, index) => {
    //       x["order"] = index + 1;
    //     });
    //     this.ModuleDataList = this.ModuleDataList;
    //     return this.ModuleArray;
    //   }
  },
  watch: {
    "$store.getters.getHotPickModules": function(newVal) {
      if (newVal) {
        this.SideNav.map(x => {
          if (x.name != "Home") {
            this.checkArrayModuleNew(x);
          }
        });
      }
    }
  },
  beforeMount() {},
  mounted() {
    this.SideNav.map(x => {
      if (x.name != "Home") {
        this.checkArrayModuleNew(x);
      }
    });
    console.log("SideNav[4].children", this.SideNav[4].children);
  },
  methods: {
    ...mapActions(["fetchUserHotPickModules"]),
    changeBgColor() {
      this.bgColor = "blue";
    },
    checkArrayModuleNew(x) {
      if (x.hasOwnProperty("children")) {
        x.children.map(y => {
          if (y.hasOwnProperty("children")) {
            this.checkArrayModuleNew(y);
          } else {
            let checkModule = this.getHotPickModules.filter(z => {
              return z.module_id == y.module_id;
            });
            if (checkModule.length > 0) {
              y["order"] = checkModule[0].order;
              y["hot_pick_id"] = checkModule[0].hot_pick_id;
              this.ModuleArray.push(y);
            }
          }
        });
      } else {
        let checkModule = this.getHotPickModules.filter(z => {
          return z.module_id == x.module_id;
        });
        if (checkModule.length > 0) {
          x["order"] = checkModule[0].order;
          x["hot_pick_id"] = checkModule[0].hot_pick_id;
          this.ModuleArray.push(x);
        }
      }
      this.ModuleArray = _.sortBy(this.ModuleArray, o => o.order);
    },
    endSort(event) {
      this.ModuleArray.map((x, index) => {
        x["order"] = index + 1;
      });
      this.onChangeDrag();
      console.log("This.modules", this.ModuleArray);
    },
    draggableElements: function() {
      return this.isEditable;
    },
    onChangeDrag: _.debounce(function() {
      let favouriteOrder = [];
      this.ModuleArray.map(x => {
        let Obj = {
          hot_pick_id: x.hot_pick_id,
          order: x.order,
          module_id: x.module_id
        };
        favouriteOrder.push(Obj);
      });
      this.UpdateModuleOrder(favouriteOrder);
    }, 1 * 3500),

    UpdateModuleOrder: function(favouriteOrder) {
      // this.isEditable = false;
      let body = {
        favourites: favouriteOrder
      };
      MasterService.updateModuleFavouriteOrder(body)
        .then(data => {
          console.log(data);
          if (data && data.status) {
            console.log("data", data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    checkNavPermissions: function(permissions) {
      if (!this.secureStore.get("USINFO")) return false;
      else {
        const { role_name } = this.secureStore.get("USINFO");
        return permissions && permissions.length > 0
          ? permissions.filter(role => role === role_name).length > 0
          : true;
      }
      // return true;
    }
  }
};
</script>
<style>
.no-data {
  font-size: 15px;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/HomeContainer/Home.vue